const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const DAY_MS = 24 * 60 * 60 * 1000;

const MONTH_DAY_FORMATTER = new Intl.DateTimeFormat("en-GB", {
  month: "short",
  day: "numeric",
  timeZone: "UTC",
});

const MONTH_DAY_YEAR_FORMATTER = new Intl.DateTimeFormat("en-GB", {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

function parseIsoCalendarDay(value) {
  const match = typeof value === "string" ? ISO_DATE_PATTERN.exec(value) : null;
  if (!match) return null;

  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, monthIndex, day));

  if (
    date.getUTCFullYear() !== year
    || date.getUTCMonth() !== monthIndex
    || date.getUTCDate() !== day
  ) {
    return null;
  }

  return date;
}

function toIsoCalendarDay(date) {
  return date.toISOString().slice(0, 10);
}

function getMonday(date) {
  const day = date.getUTCDay();
  const daysSinceMonday = day === 0 ? 6 : day - 1;
  return new Date(date.getTime() - daysSinceMonday * DAY_MS);
}

function getSunday(monday) {
  return new Date(monday.getTime() + 6 * DAY_MS);
}

function formatWeekLabel(monday, sunday) {
  const sameYear = monday.getUTCFullYear() === sunday.getUTCFullYear();
  const sameMonth = sameYear && monday.getUTCMonth() === sunday.getUTCMonth();

  if (sameMonth) {
    return `${monday.getUTCDate()}\u2013${MONTH_DAY_FORMATTER.format(sunday)}`;
  }

  if (sameYear) {
    return `${MONTH_DAY_FORMATTER.format(monday)}\u2013${MONTH_DAY_FORMATTER.format(sunday)}`;
  }

  return `${MONTH_DAY_YEAR_FORMATTER.format(monday)}\u2013${MONTH_DAY_YEAR_FORMATTER.format(sunday)}`;
}

export function groupReleasesByCalendarWeek(releases = []) {
  const groups = new Map();
  const undated = [];

  for (const release of releases) {
    const releaseDate = parseIsoCalendarDay(release?.releaseDate);
    if (!releaseDate) {
      undated.push(release);
      continue;
    }

    const monday = getMonday(releaseDate);
    const key = toIsoCalendarDay(monday);
    let group = groups.get(key);

    if (!group) {
      const sunday = getSunday(monday);
      group = {
        key,
        label: formatWeekLabel(monday, sunday),
        startDate: key,
        endDate: toIsoCalendarDay(sunday),
        shows: [],
      };
      groups.set(key, group);
    }

    group.shows.push(release);
  }

  const datedGroups = [...groups.values()].sort((left, right) => (
    left.startDate.localeCompare(right.startDate)
  ));

  if (undated.length > 0) {
    datedGroups.push({
      key: "date-tba",
      label: "Date TBA",
      startDate: null,
      endDate: null,
      shows: undated,
    });
  }

  return datedGroups;
}

export { parseIsoCalendarDay };
